<template>
  <section>
    <div class="selectBox isWindow">
      <div id="editProfileTitleRow">
        <div>
          <p class="boldEditTitle">Add Members</p>
        </div>
        <button class="closeEdit" @click="closeAddMembers"></button>
      </div>
      <input
        placeholder="Add Users"
        class="searchUser"
        v-model="searchString"
      />
      <div class="recommendedColumn">
        <div v-for="(friend, index) in friendPool" :key="index">
          <div class="eachRecommended">
            <img :src="friend.profileImage" alt="" class="recommendedImg" />
            <div>
              <p class="recommendedName">
                {{ friend.name }}
              </p>
              <p class="mutualList">{{ friend.mutuals }} mutuals</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="searchString.length > 0" class="userDropDown isWindow">
        <div v-if="loading" class="loaderPreviewContainer">
          <div class="loader"></div>
        </div>
        <div v-else>
          <template v-if="!this.totalSearch.length">
            <div class="emptyContainer">
              <img src="@/assets/Icons/EmptyIcon.svg" />
              <b>Oh no! We can't find what you're looking for</b>
            </div>
          </template>
          <ul
            class="searchContent"
            v-for="(object, index) in totalSearch"
            :key="index"
          >
            <li
              v-on:mousedown="addUser(object.doc, object.id)"
              class="profileOption"
            >
              <img :src="object.doc.profileImage" class="searchProfileImage" />
              <div class="textBox">
                {{ object.doc.firstName }} {{ object.doc.lastName }}<br />
                <p class="subText">User</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div style="height: fit-content; align-self: flex-start; margin-left: 5%">
        <div class="userContainer" v-for="(user, index) in users" :key="index">
          <div class="inputName">
            <img class="inputImage" :src="user.profileImage" />
            <img
              class="closeUser"
              src="@/assets/closeEdit.svg"
              @click="removeUser(user)"
            />
            {{ user.firstName }} {{ user.lastName }}
          </div>
        </div>
      </div>
      <div id="saveInterests">
        <button @click="inviteUsers" class="saveButton">Invite</button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import db from "@/db";
import firebase from "@/firebase";

export default {
  props: ["selectedInterests", "isProfile"],

  components: {},

  data: () => ({
    users: [],
    searchString: "",
    searchArray: [],
    totalSearch: [],
    loading: false,
    friendPool: [],
    showList: [],
    mutualPool: [],
  }),
  created() {},
  mounted() {
    this.fetchRecommendedUsers();
  },

  watch: {
    searchString() {
      if (this.searchString.length != 0) {
        this.loading = true;
        var lowerString = this.searchString.toLowerCase();
        this.searchArray = lowerString.split(/(?:-| )+/);
        this.searchDatabase();
      } else {
        this.totalSearch;
      }
    },
  },

  computed: {
    ...mapState("profile", [
      "canAddInterests",
      "isEditingInterest",
      "newInterests",
    ]),
    ...mapState("groupInfo", ["addingMembers"]),
    ...mapState("user", ["user"]),
    ...mapState("messageBoard", ["groupId", "groupName", "groupType"]),
  },

  methods: {
    closeAddMembers() {
      this.$store.commit("groupInfo/setAddingMembers", false);
    },
    async searchDatabase() {
      var totalSearch = [];
      // Search Users
      if (!/\d/.test(this.searchString)) {
        await db
          .collection("users")
          .where("school_id", "==", this.user.school_id)
          .where("firstNameKeywords", "array-contains", this.searchArray[0])
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                id: doc.id,
                searchResult: doc.data().firstName + " " + doc.data().lastName,
                type: "users",
              };
              totalSearch.push(data);
            });
          });
        await db
          .collection("users")
          .where("school_id", "==", this.user.school_id)
          .where("lastNameKeywords", "array-contains-any", this.searchArray)
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              if (totalSearch.findIndex((x) => x.id == doc.id) == -1) {
                let data = {
                  doc: doc.data(),
                  searchResult: doc.data().lastName,
                  type: "users",
                };
                totalSearch.push(data);
              }
            });
          });
      }

      // Sort search based on relevency
      var sortedSearch = [];
      for (var option = 0; option < totalSearch.length; option++) {
        let relevency = this.commonChars(
          totalSearch[option].searchResult,
          this.searchString
        );
        totalSearch[option].relevency = relevency / this.searchString.length;
        if (relevency / this.searchString.length > 0.5) {
          sortedSearch.push(totalSearch[option]);
        }
      }
      sortedSearch.sort((a, b) => b.relevency - a.relevency);
      this.loading = false;
      this.totalSearch = sortedSearch.slice(0, 8);
    },

    async fetchRecommendedUsers() {
      let listOfGroups = [
        ...this.user.groups,
        ...this.user.courses,
        ...this.user.faculties,
      ];

      let groupPool = [];

      listOfGroups.forEach((checkGroup) => {
        if (checkGroup.users) {
          groupPool = groupPool.concat(checkGroup.users);
        }
      });

      this.friendPool = this.user.links;

      this.friendPool.forEach((checkFriend) => {
        db.collection("users")
          .doc(checkFriend)
          .get()
          .then((doc) => {
            //console.log(doc.id);
            doc.data().links.forEach((mutual) => {
              if (
                !this.friendPool.includes(mutual) &&
                !this.mutualPool.includes(mutual)
              ) {
                this.mutualPool.push(mutual);
              }
            });
            //console.log(this.mutualPool);
          });
      });

      console.log(groupPool);
    },
    fetchRecommendedFriends() {
      console.log(this.user.links);
    },

    commonChars(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();
      s1 = s1.split(" ");
      s2 = s2.split(" ");
      let seenChars = [];
      let shortStr;
      let longStr;
      let counter = 0;

      if (s1.length < s2.length) {
        shortStr = s1;
        longStr = s2;
      } else {
        shortStr = s2;
        longStr = s1;
      }

      for (let i = 0; i < shortStr.length; i++) {
        var shortWord;
        var longWord;
        if (shortStr[i].length < longStr[i].length) {
          shortWord = shortStr[i];
          longWord = longStr[i];
        } else {
          shortWord = longStr[i];
          longWord = shortStr[i];
        }
        for (let j = 0; j < shortWord.length; j++) {
          if (
            longWord.indexOf(shortWord[j]) !== -1 &&
            !seenChars.includes(shortWord[j])
          ) {
            counter++;
            seenChars.push(shortWord[j]);
          }
        }
      }
      return counter;
    },
    addUser(userDoc, id) {
      userDoc.id = id;
      this.users.push(userDoc);
      this.searchString = "";
    },
    removeUser(userDoc) {
      let index = this.users.indexOf(userDoc);
      this.users.splice(index, 1);
      this.searchString = "";
    },
    inviteUsers() {
      this.users.forEach((user) => {
        var type;
        if (this.groupType === "courses") {
          type = "course";
        } else if (this.groupType === "faculties") {
          type = "faculty";
        } else {
          type = "group";
        }
        var invite = {
          createdAt: Date.now(),
          groupName: this.groupName,
          group_id: this.groupId,
          name: this.user.firstName + " " + this.user.lastName,
          profileImage: this.user.profileImage,
          type: type,
          user_id: this.user.id,
        };
        if (user.groupInvites) {
          let index = user.groupInvites.findIndex(
            (invite) => invite.group_id === this.groupId
          );
          if (index === -1) {
            user.groupInvites.push(invite);
            console.log(user.groupInvites);
            db.collection("users")
              .doc(user.id)
              .update({
                groupInvites: user.groupInvites,
              });
          }
        } else {
          db.collection("users")
            .doc(user.id)
            .update({
              groupInvites: [invite],
            });
        }
        var inviteUser = firebase
          .functions()
          .httpsCallable("sendGroupInviteNotification");
        inviteUser({
          groupName: this.groupName,
          token: user.iOSToken ? user.iOSToken : "",
          name: this.user.firstName + " " + this.user.lastName,
        });
      });
      this.$store.commit("groupInfo/setAddingMembers", false);
    },
  },
};
</script>

<style scoped src="@/styles/components/addGroupMembers.css"></style>
